import Vue from 'vue';

export default {
    init() {
        Vue.directive('submit-once', {
            bind: (el, binding, vnode) => {
                vnode.context.preventSubmit = false;

                vnode.context.submitOnceHandler = (e) => {
                    if (vnode.context.preventSubmit) {
                        e.preventDefault();
                    }

                    vnode.context.preventSubmit = true;
                };

                el.addEventListener('submit', vnode.context.submitOnceHandler);
            },
            unbind: (el, binding, vnode) => {
                el.removeEventListener('submit', vnode.context.submitOnceHandler);
            },
        });
    },
};
